<template>
  <div class="rt-section">
    <div class="rt-section__header" v-if="title || $slots.toolbar">
      <div class="rt-section__title">{{title}}</div>
      <rt-toolbar>
        <slot name="toolbar"></slot>
      </rt-toolbar>
    </div>
    <el-collapse-transition>
      <div class="rt-section__content" v-show="!isCollapsed">
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: "RtSection",
  props: {
    title: {
      type: String
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.collapsed
    };
  },
  computed: {
    iconClass() {
      return this.isCollapsed ? "el-icon-arrow-down" : "el-icon-arrow-right";
    }
  },
  methods: {
    handleClick() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
};
</script>


// WEBPACK FOOTER //
// main.vue?83c957d4